import { Outlet } from 'react-router-dom';

import { SidebarProvider } from '@/contexts/sidebar-context';

import { OrgLayoutWrapper } from './org-layout-wrapper';

export function OrgLayout() {
  return (
    <SidebarProvider initialCollapsed={false}>
      <OrgLayoutWrapper>
        <Outlet />
      </OrgLayoutWrapper>
    </SidebarProvider>
  );
}
